// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: #eceff180;
  color: rgb(38 50 56 /1) !important;
}

.MuiBreadcrumbs-separator {
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgb(38 50 56 /1);
}

/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #eceff180;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background-image: linear-gradient(#d4d5d5, #d4d5d5);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background-image: linear-gradient(#d4d5d5, #d4d5d5);
}

.mainContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  /* background-color: #0a6fb9; */
}
.subContainer {
  width: 100%;
  /* max-width: 700px; */
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #0a6fb9;
}
.subContainerFooter {
  width: 100%;
  /* max-width: 700px; */
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #0a6fb9;
}
.whiteColor {
  color: #fff;
}
.whitetextColor {
  color: #fff;
}
.backgroundColor {
  background-color: #fff;
}
.primaryColor {
  color: #0a6fb9 !important;
}
.primaryBackgroundColor {
  background-color: #0a6fb9;
}
.secendoryColor {
  background-color: #f8f8f8;
}
.secendoryBackgroundColor {
  background-color: #daeaf5 !important;
}
.dullBackgroundColor {
  background-color: #f5f4ef !important;
}
.settingBoxA:hover .settingBoxAhoverEffect {
  transform: scale(1);
  transition: all 0.5s ease;
  height: auto;
}
.status-onHold {
  background-color: #ffa07a; /* Light Salmon */
  color: #fff; /* Dark Red */
}

.status-pending {
  background-color: #f0e68c; /* Khaki */
  color: #8b4513; /* Saddle Brown */
}

.status-inProgress {
  background-color: #87ceeb; /* Sky Blue */
  color: #fff; /* Dodger Blue */
}

.status-open {
  background-color: #98fb98; /* Pale Green */
  color: #006400; /* Dark Green */
}

.status-lost {
  background-color: #ff6347; /* Tomato */
  color: #8b0000; /* Dark Red */
}

.status-sold {
  background-color: #3cb371; /* Medium Sea Green */
  color: #ffffff; /* White */
}

.status-noOpportunity {
  background-color: #d3d3d3; /* Light Grey */
  color: #696969; /* Dim Grey */
}

.status-underReview {
  background-color: #b0c4de; /* Light Steel Blue */
  color: #4682b4; /* Steel Blue */
}

.data-grid-box {
  width: 100%;
  height: calc(100vh - 100px);
  overflow: auto;
  background-color: #f9f9f9;
}
.data-grid-box-doc {
  width: 100%;
  height: calc(100vh - 360px);
  overflow: auto;
  background-color: #f9f9f9;
}
.data-grid-box-company {
  width: 100%;
  height: calc(100vh - 165px);
  overflow: scroll;
  background-color: #f9f9f9;
}

.data-grid-box .columnsClass {
  background-color: #e6f2ff;
}

.data-grid-box .MuiDataGrid-columnHeaders {
  background-color: #fef3e7;
  font-size: 15px;
  font-weight: bold;
}

.table-head {
  background-color: #fef3e7;
  position: sticky;
  top: 0;
  z-index: 1;
}

.estimation-added {
  background-color: #b4f8c8; /* Light green background */
}

.estimation-not-added {
  background-color: initial;
}

.change-request-added {
  background-color: #a0e7e5;
}
body > iframe {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,WAAW,EAAE,aAAa;AAC5B;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,cAAc,EAAE,iBAAiB;AACnC;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,WAAW,EAAE,gBAAgB;AAC/B;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf","sourcesContent":["*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  background-color: #eceff180;\r\n  color: rgb(38 50 56 /1) !important;\r\n}\r\n\r\n.MuiBreadcrumbs-separator {\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  color: rgb(38 50 56 /1);\r\n}\r\n\r\n/* width */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  background: #eceff180;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background-image: linear-gradient(#d4d5d5, #d4d5d5);\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background-image: linear-gradient(#d4d5d5, #d4d5d5);\r\n}\r\n\r\n.mainContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  /* background-color: #0a6fb9; */\r\n}\r\n.subContainer {\r\n  width: 100%;\r\n  /* max-width: 700px; */\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  background-color: #0a6fb9;\r\n}\r\n.subContainerFooter {\r\n  width: 100%;\r\n  /* max-width: 700px; */\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  background-color: #0a6fb9;\r\n}\r\n.whiteColor {\r\n  color: #fff;\r\n}\r\n.whitetextColor {\r\n  color: #fff;\r\n}\r\n.backgroundColor {\r\n  background-color: #fff;\r\n}\r\n.primaryColor {\r\n  color: #0a6fb9 !important;\r\n}\r\n.primaryBackgroundColor {\r\n  background-color: #0a6fb9;\r\n}\r\n.secendoryColor {\r\n  background-color: #f8f8f8;\r\n}\r\n.secendoryBackgroundColor {\r\n  background-color: #daeaf5 !important;\r\n}\r\n.dullBackgroundColor {\r\n  background-color: #f5f4ef !important;\r\n}\r\n.settingBoxA:hover .settingBoxAhoverEffect {\r\n  transform: scale(1);\r\n  transition: all 0.5s ease;\r\n  height: auto;\r\n}\r\n.status-onHold {\r\n  background-color: #ffa07a; /* Light Salmon */\r\n  color: #fff; /* Dark Red */\r\n}\r\n\r\n.status-pending {\r\n  background-color: #f0e68c; /* Khaki */\r\n  color: #8b4513; /* Saddle Brown */\r\n}\r\n\r\n.status-inProgress {\r\n  background-color: #87ceeb; /* Sky Blue */\r\n  color: #fff; /* Dodger Blue */\r\n}\r\n\r\n.status-open {\r\n  background-color: #98fb98; /* Pale Green */\r\n  color: #006400; /* Dark Green */\r\n}\r\n\r\n.status-lost {\r\n  background-color: #ff6347; /* Tomato */\r\n  color: #8b0000; /* Dark Red */\r\n}\r\n\r\n.status-sold {\r\n  background-color: #3cb371; /* Medium Sea Green */\r\n  color: #ffffff; /* White */\r\n}\r\n\r\n.status-noOpportunity {\r\n  background-color: #d3d3d3; /* Light Grey */\r\n  color: #696969; /* Dim Grey */\r\n}\r\n\r\n.status-underReview {\r\n  background-color: #b0c4de; /* Light Steel Blue */\r\n  color: #4682b4; /* Steel Blue */\r\n}\r\n\r\n.data-grid-box {\r\n  width: 100%;\r\n  height: calc(100vh - 100px);\r\n  overflow: auto;\r\n  background-color: #f9f9f9;\r\n}\r\n.data-grid-box-doc {\r\n  width: 100%;\r\n  height: calc(100vh - 360px);\r\n  overflow: auto;\r\n  background-color: #f9f9f9;\r\n}\r\n.data-grid-box-company {\r\n  width: 100%;\r\n  height: calc(100vh - 165px);\r\n  overflow: scroll;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.data-grid-box .columnsClass {\r\n  background-color: #e6f2ff;\r\n}\r\n\r\n.data-grid-box .MuiDataGrid-columnHeaders {\r\n  background-color: #fef3e7;\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n}\r\n\r\n.table-head {\r\n  background-color: #fef3e7;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.estimation-added {\r\n  background-color: #b4f8c8; /* Light green background */\r\n}\r\n\r\n.estimation-not-added {\r\n  background-color: initial;\r\n}\r\n\r\n.change-request-added {\r\n  background-color: #a0e7e5;\r\n}\r\nbody > iframe {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
